import { Link } from "react-router-dom";
import { Heart, Phone, Mail, Shield } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-foreground text-white/80" data-testid="footer">
      <div className="container-max px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center">
                <Heart className="w-5 h-5 text-teal-400" />
              </div>
              <span className="font-serif text-xl font-medium text-white">Goodwin Hospice</span>
            </div>
            <p className="text-sm leading-relaxed">
              Northern Virginia&apos;s premier hospice care. Supporting families with dignity and grace.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-serif text-lg text-white">Quick Links</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/chat" className="text-sm hover:text-white transition-colors">Get AI Help</Link>
              <Link to="/local-resources" className="text-sm hover:text-white transition-colors">Find Support</Link>
              <Link to="/symptoms" className="text-sm hover:text-white transition-colors">Manage Symptoms</Link>
              <Link to="/caregiver-dashboard" className="text-sm hover:text-white transition-colors">Caregiver Dashboard</Link>
            </nav>
          </div>

          {/* Resources */}
          <div className="space-y-4">
            <h4 className="font-serif text-lg text-white">Resources</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/memory-journal" className="text-sm hover:text-white transition-colors">Memory Journal</Link>
              <Link to="/ai-grief-counselor" className="text-sm hover:text-white transition-colors">Grief Support</Link>
              <Link to="/wellness-checkin" className="text-sm hover:text-white transition-colors">Daily Check-in</Link>
              <a href="https://www.nhpco.org" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-white transition-colors">National Hospice Org</a>
            </nav>
          </div>

          {/* Staff Portal */}
          <div className="space-y-4">
            <h4 className="font-serif text-lg text-white">Staff</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/hos" className="text-sm hover:text-white transition-colors">Hospice OS</Link>
              <Link to="/login" className="text-sm hover:text-white transition-colors">Staff Login</Link>
              <Link to="/staff-performance" className="text-sm hover:text-white transition-colors">Performance</Link>
            </nav>
          </div>
          <div className="space-y-4">
            <h4 className="font-serif text-lg text-white">Contact</h4>
            <div className="space-y-3">
              <a href="tel:703-578-7108" className="flex items-center gap-2 text-sm hover:text-white transition-colors">
                <Phone className="w-4 h-4" />
                703-578-7108 (24/7)
              </a>
              <a href="mailto:hospice@goodwinliving.org" className="flex items-center gap-2 text-sm hover:text-white transition-colors">
                <Mail className="w-4 h-4" />
                hospice@goodwinliving.org
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-4">
            <p className="text-sm text-white/60">© {new Date().getFullYear()} Goodwin Hospice. All rights reserved.</p>
            <Link to="/join" className="text-sm text-teal-400 hover:text-teal-300 transition-colors">
              Join Now
            </Link>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 text-sm text-white/60">
              <Shield className="w-4 h-4 text-teal-400" />
              HIPAA Compliant
            </div>
            <p className="text-sm text-white/60">This tool is not a substitute for professional medical advice.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
